import React, { Component } from 'react';
import {
  Link
} from 'react-router-dom';
import ReactDOM from 'react-dom';

import { resetWeights, resetStore } from '../Functions';
import { Svgs } from '../components/Svgs';

class Intro extends Component {

  componentDidMount() {
    document.querySelector('.app').classList.add('screen--intro');
    this.dom = ReactDOM.findDOMNode(this);
    void this.dom.offsetWidth;
    this.dom.classList.add('intro--animate-in');
    resetStore();
    resetWeights();
    window.scrollTo(0,0);
  }

  componentWillUnmount() {
    document.querySelector('.app').classList.remove('screen--intro');
  }
  
  render() {
    return (
      <div className="intro">
        <Svgs svg="ApLogo" class="intro__logo" />
        <h1>Welcome.</h1>
        <p>Australia Post has a large range of Financial Services tools to help your business connect with its customers.</p> 
        <p>Find which ones are right for you.</p>
        <Link to={this.props.firstQuestionUrl} className="btn"><span>Lets get started</span> <Svgs width="8" height="8" svg="RightChevron" /></Link>
      </div>
    );
  }
}

export default Intro;



// WEBPACK FOOTER //
// ./src/screens/Intro.js